import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import JSZip from 'jszip';
import moment from 'moment';

const initialState = {
  startCurrentScore: {},
  sc_error: '',
  sc_status: 'idle',
};

export const fetchStartCurrent = createAsyncThunk('dispute-center/fetchStartCurrent', async () => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append('Token', accessToken);
  let response = await axios.post('Form/getDisputeCenterStartCurrentScore', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

export const generateLetters = createAsyncThunk('dispute-center/generateLetters', async () => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append('Token', accessToken);
  let response = await axios.post('Form/generatePlanLetters', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});



export const downloadAllLetters = createAsyncThunk('dispute-center/downloadAllLetters', async ({ filePaths, name }) => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append('Token', accessToken);

  // Create a zip folder
  const zip = new JSZip();
  filePaths.forEach(path => {
    zip.file(
      path.split('/').pop(),
      axios.get(path, { responseType: 'blob' }).then(res => res.data)
    );
  });

  // Download the zip folder from the header
  const content = await zip.generateAsync({ type: 'blob' });
  const url = window.URL.createObjectURL(content);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${name} - Dispute Letters.zip`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  return true;
});

export const downloadActiveLetter = createAsyncThunk('dispute-center/downloadActiveLetter', async obj => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append('Token', accessToken);
  formData.append('letter_id', obj.letter_id);
  formData.append('client_id', obj.client_id);
  let response = await axios.post('form/UpdateLetterDownloadStatus', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

export const confirmDisputeItems = createAsyncThunk('dispute-center/confirmDisputeItems', async () => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append('Token', accessToken);
  let response = await axios.post('form/confirmReportAuditDisputeItems', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

export const confirmDisputeEmailed = createAsyncThunk('dispute-center/confirmDisputeEmailed', async selectedDate => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append('email_date', moment(selectedDate).format('YYYY-MM-DD'));
  formData.append('Token', accessToken);
  let response = await axios.post('form/UpdateLetterEmailStatus', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

export const checkDownloadStatus = createAsyncThunk('dispute-center/checkDownloadStatus', async () => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append('Token', accessToken);

  let response = await axios.post('form/checkDownloadStatus', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

const removeLocalStorage = () => {
  localStorage.removeItem('username');
  localStorage.removeItem('isAdmin');
  localStorage.removeItem('company_id');
  localStorage.removeItem('company_logo');
  localStorage.removeItem('accessToken');
};

const DisputeCenterSlice = createSlice({
  name: 'dispute-center',
  initialState,
  reducers: {
    blankStartCurrentScore: state => {
      state.startCurrentScore = {};
      state.sc_error = '';
      state.sc_status = 'idle';
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchStartCurrent.pending, state => {
      state.sc_status = 'loading';
    });
    builder.addCase(fetchStartCurrent.fulfilled, (state, action) => {
      state.sc_status = 'succeeded';
      state.startCurrentScore = action.payload;
      state.sc_error = '';
    });
    builder.addCase(fetchStartCurrent.rejected, (state, action) => {
      state.sc_status = 'failed';
      state.startCurrentScore = {};
      state.sc_error = action.error.message;
    });
    builder.addCase(confirmDisputeEmailed.fulfilled, (state, action) => {
      // state.sc_status = 'idle';
      state.sc_error = '';
    });
  },
});

export const { blankStartCurrentScore } = DisputeCenterSlice.actions;

export default DisputeCenterSlice.reducer;
